import React from 'react';
import styled from 'styled-components';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { getThemeTopBarHeight } from './components/TopBar';

const AppWrapper = styled.div`
  margin-top: ${getThemeTopBarHeight};
`;

const App = ({ route }) => (
  <AppWrapper className="app-wrapper">
    <Helmet>
      {/* Set site wide header info here and specific overrides in pages */}
      <title>Well Pharmacy</title>
      <meta name="description" content="Well Pharmacy - NHS prescriptions delivered to your door for free" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <link rel="canonical" href="https://pharmacy.well.co.uk" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=2, user-scalable=yes"
      />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://pharmacy.well.co.uk" />
      <meta property="og:title" content="Well Pharmacy" />
      <meta property="og:description" content="NHS prescriptions delivered to your door for free." />
      <meta property="og:image" content="/og/open_graph.png" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1000" />
      <meta property="og:image:height" content="1000" />
      <meta property="og:site_name" content="Well Pharmacy" />
      <link rel="apple-touch-icon" sizes="56x56" href="/favicons/icon-56x56.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/favicons/icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/favicons/icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/favicons/icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/favicons/icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/favicons/icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/favicons/icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/favicons/icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/favicons/icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicons/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/favicons/icon-192x192.png" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/favicons/icon-144x144.png" />
      <meta name="theme-color" content="#ffffff" />
      <link rel="manifest" href="/favicons/site.webmanifest" />
      <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="msapplication-config" content="/favicons/browserconfig.xml" />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
    {renderRoutes(route.routes)}
  </AppWrapper>
);

App.propTypes = {
  route: PropTypes.object.isRequired,
};

export default App;
